import React from 'react'
import { ModalHeader as Header } from '~ui'

export default function CollectionSharingTitleView({ title }) {
    return (
        <Header 
            data-no-shadow
            title={title} />
    )
}